class CartDrawerUpsell extends HTMLElement {
  connectedCallback() {
    this.onCartUpdated = (event) => this.updateVisibility(event.detail?.cart);
    this.onPubsubCartUpdate = (data) => this.updateVisibility(data?.cart);

    this.bindAddButtons();

    document.addEventListener('cart:updated', this.onCartUpdated);
    if (window.FoxTheme?.pubsub) {
      this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
        FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
        this.onPubsubCartUpdate
      );
    }
  }

  disconnectedCallback() {
    document.removeEventListener('cart:updated', this.onCartUpdated);
    this.cartUpdateUnsubscriber?.();
  }

  get sectionsToBundle() {
    const sectionIds = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionIds } })
    );
    return sectionIds;
  }

  bindAddButtons() {
    this.querySelectorAll('[data-cdu-add]').forEach((btn) => {
      btn.addEventListener('click', (event) => this.handleAddClick(event, btn));
    });
  }

  updateVisibility(cart) {
    if (!cart?.items) return;

    const cartVariantIds = new Set(cart.items.map((item) => item.variant_id));
    const allVariantIds = (this.dataset.variantIds || '')
      .split(',')
      .map(Number)
      .filter(Boolean);

    const allInCart =
      allVariantIds.length > 0 && allVariantIds.every((id) => cartVariantIds.has(id));
    this.hidden = allInCart;
  }

  handleAddClick(event, btn) {
    event.preventDefault();
    if (!btn || btn.disabled) return;

    const variantId = Number(btn.dataset.variantId);
    if (!variantId) return;

    btn.disabled = true;
    btn.classList.add('btn--loading');

    const sectionsToBundle = this.sectionsToBundle;
    const config = FoxTheme.utils.fetchConfig('javascript');
    config.body = JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: sectionsToBundle,
      sections_url: window.location.pathname,
    });

    fetch(FoxTheme.routes.cart_add_url, config)
      .then((response) => response.json())
      .then(async (addResponseJson) => {
        if (addResponseJson.status) {
          throw new Error(addResponseJson.message || 'Unable to add item');
        }

        const cartJson = await (
          await fetch(FoxTheme.routes.cart_url, FoxTheme.utils.fetchConfig())
        ).json();
        cartJson['sections'] = addResponseJson['sections'] || {};

        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
        document.dispatchEvent(
          new CustomEvent('cart:updated', { detail: { cart: cartJson } })
        );
      })
      .catch((error) => {
        console.error('[cart-drawer-upsell]', error);
      })
      .finally(() => {
        btn.classList.remove('btn--loading');
        if (!this.hidden) {
          btn.disabled = false;
        }
      });
  }
}

customElements.define('cart-drawer-upsell', CartDrawerUpsell);
